/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Modal, ThemeProvider } from "@mui/material";
import { DataGrid, GridColDef, GridRowId } from "@mui/x-data-grid";
import { format, parseISO } from "date-fns";
import { BASE_API_URL } from "../API/Base";
import AxiosInstance from "../API/axios";
import theme from "../theme";
import { CustomerDetails, WrapTextCellProps } from "../types";
interface CustomerDataModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectedCustomer: (selectedCP: any) => void;
}

export const formatDate = (dateString: string | null) => {
  if (!dateString) {
    return "N/A"; // or some default value
  }

  const date = parseISO(dateString);
  return format(date, "M/dd/yyyy h:mm:ss a");
};

const CustomerDataModal: React.FC<CustomerDataModalProps> = ({
  isOpen,
  onClose,
  onSelectedCustomer,
}) => {
  const [CustomerDetailsData, setCustomerDetailsData] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(5);
  const [rowCount, setRowCount] = useState<number>(0);

  // const theme: Theme = useThemeStore((state) => state.theme);

  const fetchPageData = async (page: number, pageSize: number) => {
    try {
      setLoading(true);
      const response = await AxiosInstance.get(
        `${BASE_API_URL}/admin/v1/customer-details`,
        {
          params: {
            page,
            per_page: pageSize,
          },
        }
      );
      if (
        !response.data ||
        !response.data.customer_data ||
        response.data.total_count == null
      ) {
        console.error("Invalid response format:", response.data);
        console.error("Invalid response format:", response.data);
        setLoading(false);
        return;
      }
      const formattedData = response.data.customer_data.map(
        (row: CustomerDetails, index: number) => ({
          ...row,
          actionsID: startIndex + index + 1,
          Id: row.Id,
        })
      );

      setCustomerDetailsData(formattedData);
      setRowCount(response.data.total_count);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchPageData(currentPage, pageSize);
    }
  }, [isOpen]);

  // Calculate total pages
  // const totalPages = Math.ceil(rowCount / pageSize);

  // Calculate start and end index for the visible rows
  const startIndex = (currentPage - 1) * pageSize;

  // const handlePageChange = (page: number) => {
  //   setCurrentPage(page);
  // };
  const columns: GridColDef[] = [
    {
      field: "Id",
      headerName: "ID",
      width: 70,
      renderCell: (params) => (
        <div className="cellWithStatus">{params.value || "N/A"}</div>
      ),
    },
    {
      field: "Customer_Name",
      headerName: "Customer Name",
      width: 150,
      renderCell: (params) => (
        <div className={`cellWithStatus ${params.value ? "" : "inactive"}`}>
          {params.value || "N/A"}
        </div>
      ),
    },
    {
      field: "Address_1",
      headerName: "Address",
      width: 250,
      renderCell: (params) => (
        <div className={`cellWithStatus ${params.value ? "" : "inactive"}`}>
          {params.value || "N/A"}
        </div>
      ),
    },
    {
      field: "City_Name",
      headerName: "City",
      width: 150,
      renderCell: (params) => (
        <div className={`cellWithStatus ${params.value ? "" : "inactive"}`}>
          {params.value || "N/A"}
        </div>
      ),
    },
    {
      field: "State_Name",
      headerName: "State",
      width: 150,
      renderCell: (params) => (
        <div className={`cellWithStatus ${params.value ? "" : "inactive"}`}>
          {params.value || "N/A"}
        </div>
      ),
    },
    {
      field: "Product_Name",
      headerName: "Product Name",
      width: 150,
      renderCell: (params) => (
        <div className={`cellWithStatus ${params.value ? "" : "inactive"}`}>
          {params.value || "N/A"}
        </div>
      ),
    },
  ];

  const filteredCPData = CustomerDetailsData.filter((row: any) =>
    row.CP_Name.toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleRowSelection = (rowSelectionModel: GridRowId[]) => {
    const selectedRowId =
      rowSelectionModel.length > 0 ? rowSelectionModel[0].toString() : null;

    const selectedData = selectedRowId
      ? CustomerDetailsData.find(
          (row: any) => row.Id === parseInt(selectedRowId, 10)
        )
      : null;

    // Ensure selectedData is not null before logging the whole row data
    if (selectedData !== null && selectedData !== undefined) {
      // Pass both selectedCity and selectedData to onSelectCity
      onSelectedCustomer(selectedData); // Change this line
    }
    onClose();
  };

  // const WrapTextCell: React.FC<WrapTextCellProps> = ({ value }) => {
  //   return <div style={{ whiteSpace: "pre-wrap" }}>{value}</div>;
  // };

  return (
    <ThemeProvider theme={theme}>
      <Modal open={isOpen} onClose={onClose}>
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full md:w-1/2 max-w-screen-md bg-white dark:bg-darkPrimary shadow-lg p-4 md:p-8 rounded-lg">
          <h2 className="text-lg md:text-xl font-semibold bg-gray dark:bg-[#222B45] py-2 px-4 text-primary dark:text-white">
            Customer Selection
          </h2>
          {/* <SearchInput
            value={searchValue}
            onChange={setSearchValue}
            placeholder="Search by customer name"
          /> */}

          <Box
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#00A99D",
                borderBottom: "none",
                fontWeight: "bold",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: "#fff !important",
              },
              "& .MuiDataGrid-colCell": {
                color: `#fff !important`,
              },
              "& .MuiDataGrid-footerContainer": {
                color: `#fff !important`,
              },
              "& .MuiTablePagination-toolbar": {
                color: "#000 !important",
              },
              "& .MuiSelect-select-MuiInputBase-input .MuiSelect-icon": {
                color: "#000 !important",
              },
              "& .MuiTablePagination-toolbar svg": {
                fill: "#000 !important",
              },

              overflowX: "auto",
              "& .cellWithStatus": {
                color: "#000",
              },
            }}
          >
            <div className="h-80 overflow-y-auto mt-4">
              <DataGrid
                columns={columns}
                rows={filteredCPData}
                getRowId={(row) => row.Id}
                loading={loading}
                onRowSelectionModelChange={handleRowSelection}
                pagination
                pageSizeOptions={[5, 10, 25, 50]}
                initialState={{
                  pagination: { paginationModel: { pageSize: 10 } },
                }}
              />
            </div>
          </Box>

          <button
            className="bg-primary text-white rounded-md px-4 py-2 mt-4 focus:outline-none"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </Modal>
    </ThemeProvider>
  );
};

export default CustomerDataModal;
